import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxImageCompressService } from 'ngx-image-compress';
import { Observable, from } from 'rxjs';
import { OptimizeImageService } from '../../modals/image-modal/optimize-image.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ItemType } from '../search-select.component';

@Component({
  selector: 'app-create-item',
  templateUrl: './create-item.component.html',
  styleUrls: ['./create-item.component.scss']
})
export class CreateItemComponent {
  name:string = ''
  constructor(
    private formBuilder: UntypedFormBuilder,
    private imageCompress: NgxImageCompressService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private device: DeviceDetectorService,
  ){}
  ngOnInit(): void {
    this.name = this.data['name']
  }
  formGroup = this.formBuilder.group({
    city: new UntypedFormControl('', Validators.required),
    image: new UntypedFormControl('', Validators.required),
  })
  updateCity(e:ItemType|null){
    this.formGroup.controls['city'].setValue(e)
  }
  isDesktop():boolean{
    return this.device.isDesktop()
  }
  compressImage(img: any):Observable<string>{
    img = img.replace('image/jpeg' , 'image/webp')
    img = img.replace('image/jpg' , 'image/webp')
    img = img.replace('image/JPEG' , 'image/webp')
    img = img.replace('image/JPG' , 'image/webp')
    img = img.replace('image/Jpeg' , 'image/webp')
    img = img.replace('image/png' , 'image/webp')
    img = img.replace('image/Png' , 'image/webp')
    img = img.replace('image/PNG' , 'image/webp')
    return from(this.imageCompress.compressFile(img, -1, 80, 80 , 200 , 200))
  } 
  onFileChange(e:any) {
    let file = e.target.files[0]; // <--- File Object for future use.
    let fileType = file!.name.split('.').at(-1)
    let array_type = ['jpg', 'png','PNG','JPEG','JPG', 'jpeg', 'gif', 'bmp', 'webp' , 'tif', 'tiff']
    if(array_type.includes(fileType)){
      // this.formGroup.controls['image'].setValue(file ? file : null); // <-- Set Value for Validation
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.compressImage(reader.result).subscribe(
          data=> {
            this.formGroup.controls['image'].setValue(data)
          }
        )
      };
    }
  }
  getImage():Observable<string>{
    return this.formGroup.controls['image'].valueChanges
  }
  getFormData():boolean{
    return this.formGroup.valid
  }
  getImageFile(img:any){
    let arr = img.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);    
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${this.name}.webp`, {type:mime});
  }
  exit():void{
    this.dialog.getDialogById('create-item-component')?.close(null)
  }
  done():void{
    if(this.getFormData()){
      let f:FormData = new FormData()
      f.append('name', this.name)
      f.append('city', this.formGroup.controls['city'].value)
      let logo = this.getImageFile(this.formGroup.controls['image'].value)
      console.log('logo', logo)
      f.append('logo', logo)
      this.dialog.getDialogById('create-item-component')?.close(f)
    }
  }
}
